import React from 'react';

export const Button = ({ children, variant = 'primary', className = '', ...props }) => {
  const baseClass = variant === 'primary' ? 'btn-primary-custom' : 'btn-outline-custom';
  return (
    <button className={`btn ${baseClass} ${className}`} {...props}>
      {children}
    </button>
  );
};

export const Card = ({ children, className = '', ...props }) => (
  <div className={`card-custom ${className}`} {...props}>
    {children}
  </div>
);

export const Section = ({ children, className = '', id, ...props }) => (
  <section id={id} className={`${className}`} {...props}>
    {children}
  </section>
);

export const Container = ({ children, className = '', ...props }) => (
  <div className={`container ${className}`} {...props}>
    {children}
  </div>
);
